<template>
  <div id="hiyamizu"  v-bind:class="{ 'pc-style':pcStyle,'mob-style':mobStyle}">
    <header>
      <HeaderWhite/>
    </header>
    <main>
      <div class="logo-area">
        <img  id="hiyamizu_logo" src="/assets/img/hiyamizu/logo.svg">
      </div>
      <!-- <Carousel :selectTagKey="'hiyamizu'"/> -->
      <!-- hiyamizu img area -->
      <div class="hiyamizu-img-area">
        <img class="hiyamizu-img" src="/assets/img/hiyamizu/hiyamizu_01.jpg">
      </div>
      <div class="area-background">
        <div class="overview hiyamizu-contents-bottom">
          <div class="overview_text">
            愛知県豊橋市駅前エリアにある通称 "水上ビル" のなかに「冷や水」はあります。<br>
            舞台映像作家の山田晋平のアトリエ兼住居であり、(株)青空の事務所です。<br>
            映像制作や教育普及など、様々な芸術活動の拠点であるとともに、<br>
            定期的にアートイベントを開催し、この街に暮らす人々と芸術について思考する場所でもあります。            
            </div>
        </div>
        <div class="address_hiyamizu hiyamizu-contents-bottom">
          <span class="title_caption hiyamizu-title font__roboto hiyamizu-title_address">ADDRESS</span>
          <div class="address_text">
            <span class="address-detail postal_code">〒440-0888</span>
            <span class="address-detail">豊橋市駅前大通三丁目118番地先</span>
            <span class="address-detail">大豊ビルA-2棟 冷や水</span><br>
            <span class="address-detail">豊橋駅から徒歩13分</span>
          </div>
          <div class="google-map-area">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3277.750458848807!2d137.3868381152339!3d34.76187838041869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f7!3m3!1m2!1s0x6004d31ef7be0d31%3A0x5d8eb2bd1886907!2z5Ya344KE5rC0IC8g5qCq5byP5Lya56S-6Z2S56m6!5e0!3m2!1sja!2sjp!4v1633043671685!5m2!1sja!2sjp" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
          </div>
        </div>
        <div class="news hiyamizu-contents-bottom">
          <span class="title_caption hiyamizu-title font__roboto">NEWS</span>
          <ArchiveList
            v-for="newsData in newsList"
            :key="newsData.id"
            :eventDate="newsData.event_date"
            :id="newsData.id"
            :title="newsData.title"
            :archiveA="newsData.detail_a"
            :archiveB="newsData.detail_b"
            :archiveC="newsData.detail_c"
            :tirasiName="newsData.tirasi_name"
            :linkName="newsData.link_name"
            :linkUrl="newsData.link_url"
          />
        </div>
        <div class="youtube hiyamizu-contents-bottom">
          <span class="title_caption hiyamizu-title font__roboto" style="text-align=center">YOUTUBE</span>
          <div class="youtube-list">
            <div  class="youtube-data" v-for="youtubeData in this.youtubeList" v-bind:key="youtubeData.kind">
              <div class="youtube-thumbnail-area" v-on:click="startYoutube(youtubeData.id.videoId)">
                <img class="youtube-play-icon" src="/assets/img/hiyamizu/play_icon.svg">
                <img  class="youtube-thumbnail" v-bind:src="youtubeData.snippet.thumbnails.high.url"><br>
              </div>
              <span class="youtube-date">{{ changePublishedateFormat(youtubeData.snippet.publishedAt) }}</span>
              <span class="youtube-title">{{ youtubeData.snippet.title }}</span>
            </div>
          </div>
          <div class="link-more-area">
            <a class="link-more font__roboto" href="https://www.youtube.com/channel/UCwyj1dOlijs19k1fRxb_0Mw" target="_blank" rel="noopener noreferrer">MORE</a>
          </div>
        </div>
        <div class="instagram hiyamizu-contents-bottom">
          <span class="title_caption hiyamizu-title font__roboto">INSTAGRAM</span><br>
          <div v-show="instagramPc" class="instagram-pc instagram-block">
            <div class="instagram-data_block instagram-data_block-pc" v-for="instagramCutData in this.instagramList" v-bind:key="instagramCutData.index">
              <HiyamizuInstagramContent class="instagram-data"
                  v-for="instagramData in instagramCutData"
                  :permalink="instagramData.permalink"
                  :key="instagramData.id"
                  :media_url="instagramData.media_url"
                  :timestamp="changePublishedateFormat(instagramData.timestamp)"
                  :caption="instagramData.caption"
              />
            </div>
          </div>
          <div v-show="instagramSp" class="instagram-sp instagram-block">
            <div class="instagram-data_block instagram-data_block-sp" v-for="instagramCutDataSp in this.instagramDataListSp" v-bind:key="instagramCutDataSp.index">
              <HiyamizuInstagramContent class="instagram-data"
                  v-for="instagramDataSp in instagramCutDataSp"
                  :permalink="instagramDataSp.permalink"
                  :key="instagramDataSp.id"
                  :media_url="instagramDataSp.media_url"
                  :timestamp="changePublishedateFormat(instagramDataSp.timestamp)"
                  :caption="instagramDataSp.caption"
              />
            </div>
          </div>
          <div class="link-more-area">
            <a class="link-more font__roboto" href="https://www.instagram.com/hiya_mizu/" target="_blank" rel="noopener noreferrer">MORE</a>
          </div>
        </div>
        <div class="archiveList hiyamizu-contents-bottom">
          <span class="title_caption hiyamizu-title font__roboto">ARCHIVE</span>
          <ArchiveList
            v-for="archiveData in archiveList"
            :key="archiveData.id"
            :eventDate="archiveData.event_date"
            :id="archiveData.id"
            :title="archiveData.title"
            :archiveA="archiveData.detail_a"
            :archiveB="archiveData.detail_b"
            :archiveC="archiveData.detail_c"
            :tirasiName="archiveData.tirasi_name"
            :linkName="archiveData.link_name"
            :linkUrl="archiveData.link_url"
          />
        <div class="link-more-area">
          <router-link v-on:click.native="mbNavOff()"  class="link-more font__roboto" v-bind:to ="{ name:'archive'}">MORE</router-link>
          <!-- <a class="link-more font__roboto" href="https://www.youtube.com/channel/UCwyj1dOlijs19k1fRxb_0Mw" target="_blank" rel="noopener noreferrer">MORE</a> -->
        </div>
        </div>
      </div>
      <!-- Youtube再生エリア -->
      <div v-show="youtubeVideoAreaShow" class="youtube-video-area" >
        <img v-on:click="youtubeVideoAreaClose()" class="youtube-close-button" src="/assets/img/hiyamizu/close.svg">
        <div class="youtube-play-area">
          <iframe class="youtube-video" v-bind:src="this.youtubeUrl" allowfullscreen frameborder="0" ></iframe>
        </div>
      </div>
    </main>
    <footer class="hiyamizu-page-bottom">
      <Footer/>
    </footer>
  </div>
</template>

<script>
import axios from 'axios'
import HeaderWhite from '@/components/common/HeaderWhite.vue'
import ArchiveList from '@/components/hiyamizu/ArchiveList.vue'
import changeDateFormat from '../util/formatter';
import Footer from '../components/common/Footer'
import HiyamizuInstagramContent from '@/components/hiyamizu/HiyamizuInstagramContent.vue';

export default {
  name: 'hiyamizu',
  components: {
    HeaderWhite,
    Footer,
    // Carousel,
    ArchiveList,
    HiyamizuInstagramContent
  },
  data:function(){
    return {
      windowSize: window.innerWidth,
      // 引き渡すデータリスト
      youtubeList: [],
      //ニュース用リスト
      newsList: {},
      // アーカイブ用リスト
      archiveList: {},
      archiveListAll: {},
      // Youtube再生エリア表示非表示
      youtubeVideoAreaShow: false,
      // Youtube再生リンク
      youtubeUrl: "",
      changedpublisheDate:"",
      // Instagramリスト
      instagramPc: true,
      instagramSp: false,
      isDisplay:false,
      instagramGetDataList:[],
      instagramList: [],
      instagramDataListSp: [],
      //スタイル切り分け
      pcStyle: true,
      mobStyle: false,
      ipadStyle: false,
    }
  },
    created() {
    // モバイル用のヘッダースタイル適応
    if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('Android') > 0 || 
      navigator.userAgent.indexOf('iPad') > 0 ) {
        this.pcStyle = false;
        this.mobStyle = true;
    }
    this.handleResize();
  },
//axiosによるデータ取得処理
  mounted () {
    // youtubeデータ取得
    axios.get('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCwyj1dOlijs19k1fRxb_0Mw&maxResults=3&order=date&type=video&key=AIzaSyDS-ifHe4uT_UWym3HIz7CFSN-7hJzuwpM')
    .then((response) => {
      // this.youtubeList = []
      this.youtubeList = response.data.items;
    })
    // Instagramデータ取得
    // DBからトークン情報取得
    const instagramBaseUrl = 'https://graph.instagram.com/me/media?fields=id,caption,permalink,media_url,timestamp&access_token=';
    axios.get('https://yamadashimpei.com:9876/instagram_api')
    .then((response) => {
      axios.get(instagramBaseUrl + response.data.token)
      .then((response) => {
        // PC用
        this.instagramGetDataList = response.data.data.filter((t, index) => index < 18);
        const base = this.instagramGetDataList.length;
        const split_cnt = 6;
        for(let i=0; i<Math.ceil(base/split_cnt); i++) {
          let multiple_cnt = i * split_cnt
          let result = this.instagramGetDataList.slice(multiple_cnt,multiple_cnt + split_cnt)
          this.instagramList.push(result)
        }
        // SP用
        this.instagramGetDataListSp = response.data.data.filter((t, index) => index < 8);
        const baseSp = this.instagramGetDataListSp.length;
        const split_cnt_sp = 2;
        for(let i=0; i<Math.ceil(baseSp/split_cnt_sp); i++) {
          let multiple_cnt = i * split_cnt_sp
          let result = this.instagramGetDataListSp.slice(multiple_cnt,multiple_cnt + split_cnt_sp)
          this.instagramDataListSp.push(result)
        }
      })
    })

    // アーカイブデータ取得
    axios.get('https://yamadashimpei.com:9876/archive_api')
    .then((response) => {
      this.archiveListAll = response.data.response;
      this.newsList = response.data.response.filter((t, index) => index < 3);
      this.archiveList = response.data.response.filter((t, index) => index >= 3 && index < 8);
    })
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    // 日付データフォーマット変更
    changePublishedateFormat: function(date) {
      var changedPublishedate = changeDateFormat(date)
      return changedPublishedate
    },
    startYoutube: function(videoId) {
      var youtubeUrlBase = "https://www.youtube.com/embed/";
      var relatedVideosStatus = "?rel=0"
      this.youtubeUrl = youtubeUrlBase + videoId + relatedVideosStatus;
      this.youtubeVideoAreaShow = true
    },
    youtubeVideoAreaClose: function() {
      this.youtubeVideoAreaShow = false
      this.youtubeUrl = ""
    },
    handleResize: function(){
      this.windowSize = window.innerWidth;
      if ( this.windowSize < 768){
        this.instagramPc = false;
        this.instagramSp = true;
      } else { 
        this.instagramPc = true;
        this.instagramSp = false;
      }
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
.none {
  display: none;
}
  // 冷や水キャプション
  .title_caption {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 20px;
    display: inline-block;
    line-height: normal;
    font-size: 18px;
    border-bottom: solid 1px #000000;
    margin-bottom: 40px;
  }
.link-more-area {
  width: 100%;
  text-align: center;
  margin-top: 40px;
  .link-more {
    color: #969696;
    border-bottom: solid 1px #969696;
  }
}
.logo-area {
  position: relative;
  width: 100vw;
  height: 80vw;
}
#hiyamizu_logo {
  position: absolute;
  width: 80vw;
  z-index: -1;
  left: 50%;
  transform: translateX(-50%);
  padding: 21vw 0;
}
.hiyamizu-img-area {
  background: #ffffff;
}
.hiyamizu-img {
  width: 100%;
}
// コンテンツ余白
.hiyamizu-contents-bottom {
  padding-bottom: 80px;
}
// 概要
.overview {
  position: relative;
}
.overview_text {
  text-align: center;
    font-size: 16px;
    padding-top: 20px;
    margin: 0 10vw;
  br {
    display: inline;
  }
}
// アドレス
.address_text {
  text-align: center;
  padding-bottom: 15px;
  font-size: 15px;
  margin-left: 6vw;
  margin-right: 6vw;
}
.address-detail {
  display: inline-block;
}
.postal_code {
    display: block;
}
.google-map-area {
  margin-left: 8vw;
  margin-right: 8vw; 
  height: 50vw;
}
// Youtube
.youtube-data {
  // width: 90%;
  margin-left: 8vw;
  margin-right: 8vw;
  margin-bottom: 30px;
}
.youtube-thumbnail-area {
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 47vw;
  object-fit: cover;
  overflow: hidden;
    .youtube-play-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 20%;
    }
    .youtube-thumbnail {
      width: 100%;
      height: 47vw;
      object-fit: cover;
  }
}
.youtube-channel-link {
  color: #000000;
  border-bottom: solid 1px #000000;
}

// Youtube再生時
.youtube-video-area {
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: hidden;
    z-index: 10;
    top: 0;
    background: #000000;
    transform: translateY(0);
  .youtube-close-button {
    cursor: pointer;
    position: absolute;
    width: 20px;
    right: 5%;
    top: 3%;
    transform: translate(3%,-5%);
  }
}
.youtube-play-area {
  position: absolute;
  width: 1000px;
  height: 563px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  .youtube-video {
    width: 100%;
    height: 100%;
  }
}
.youtube-date {
 font-size: 14px;
}
.youtube-title {
  // タイトルが1行以上の場合省略
  overflow: hidden;
  height: auto;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-size: 15px;
}
// Instagramコンテンツ
.instagram-data_block {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.instagram-data_block-sp {
  margin-bottom: 2.1vw;

}
.instagram-block:last-child {
  margin-bottom: 0;
}
.instagram-sp {
  margin-left: 8vw;
  margin-right: 8vw;
}
// ipad以下
@media screen and (max-width: 1024px) { 
  .youtube-play-area {
    width: 100vw;
    height: 56.3vw;
    .youtube-video {
      width: 100%;
      height: 100%;
    }
  }  
}
// PC
@media screen and (min-width: 768px) {
  #hiyamizu {
  line-height: 8.4vw;
}
  // 会社概要・冷や水キャプション
  .title_caption {
    display: inline-block;
    line-height: normal;
    font-size: 22px;
    border-bottom: solid 1px #000000;
    margin-bottom: 45px;
  }
  #hiyamizu {
    line-height: 2em;
  }
  .hiyamizu-title_address {
    margin-bottom: 40px;
  }
  .logo-area {
    height: 42vw;
  }
  #hiyamizu_logo {
    position: fixed;
    width: 50vw;
    max-width: 1200px;
    padding: 10.5vw 0;
  }
  // コンテンツ余白
.hiyamizu-contents-bottom {
  padding-bottom: 100px;
}
  .area-background {
    background: #ffffff;
    width: 60vw;
    max-width: 1500px;
    margin: 0 auto;
  }
  .overview_text {
    text-align: center;
    font-size: 16px;
    padding-top: 100px;
    margin: 0;
    br {
      display: inline;
    }
  }

  // アドレス
  .address_text {
    padding-bottom: 20px;
    font-size: 14px;
    margin: 0;
  }
  .google-map-area {
    width: 100%;
    height: 40vw;
    margin: 0;
  }
  .postal_code {
      display: inline;
      margin-right: 1vw;
  }
  // Youtube
  .youtube-list {
    display: flex;
    justify-content: space-between;
  }
  .youtube-data {
    width: 32%;
    margin: 0;
  }
  .youtube-thumbnail-area {
    height: 10.7vw;
      .youtube-thumbnail {
        height: 10.7vw;
    }
  }
  .youtube-date {
    display: block;
    font-size: 16px;
    margin-top: 0.4em;
  }
  // タイトルが2行以上の場合省略
  .youtube-title {
    height: 62px;
    -webkit-line-clamp: 2;
    font-size: 16px;
  }
}
.instagram-data_block-pc {
  margin-bottom: 1.1vw;
}
// モバイル系端末のみ
.mob-style {
  .overview_text {
    text-align: justify;
    br {
      display: none;
    }
  }
  
}

</style>